import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

interface CaseMessageCountStore {
  caseMessageCounts: Record<string, string[]>;
  previousCaseMessageCountsId: string | null;

  actions: {
    setCaseMessageCount: (caseId: string, messageId: string) => void;
    resetCaseMessageCount: (caseId: string) => void;
    setPreviousCaseMessageCountsId: (caseId: string | null) => void;
  };
}

export const caseMessageCountStore = create<CaseMessageCountStore>((set, get) => ({
  caseMessageCounts: {},
  previousCaseMessageCountsId: null,
  actions: {
    setCaseMessageCount: (caseId: string, messageId: string) => {
      const state = get();
      const caseMessageCounts = { ...state.caseMessageCounts };
      const existing = caseMessageCounts[caseId] ?? [];
      if (existing.includes(messageId)) return;
      caseMessageCounts[caseId] = [...existing, messageId];
      set({ caseMessageCounts });
    },

    resetCaseMessageCount: (caseId: string) => {
      const state = get();
      const caseMessageCounts = { ...state.caseMessageCounts };
      delete caseMessageCounts[caseId];
      set({ caseMessageCounts });
    },

    setPreviousCaseMessageCountsId: (caseId: string | null) => {
      set({ previousCaseMessageCountsId: caseId });
    },
  },
}));

// selectors

/**
 * Get all items
 */

export const useCaseMessageCountStateStore = () =>
  caseMessageCountStore(useShallow((state) => state.caseMessageCounts));

export const useCaseMessageCountByCaseIdStateStore = (caseId: string) =>
  caseMessageCountStore(useShallow((state) => (state.caseMessageCounts[caseId] ?? [])?.length));

export const usePreviousCaseMessageCountsIdStateStore = () =>
  caseMessageCountStore(useShallow((state) => state.previousCaseMessageCountsId));

// actions
export const useCaseMessageCountActionsStore = () => caseMessageCountStore(useShallow((state) => state.actions));
